module.exports = __webpack_public_path__ + "img/icon_verify.8fe7aa93.png";